import React from "react";
import { Box, Stack, Typography } from "@mui/material";

const SiteBanner = () => {
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        aspectRatio: { xs: "180 / 95", xsm: "300 /70", xxl: "4.4 / 1" },
        overflow: "hidden",
      }}
    >
      <Box>
        <img
          src="/images/banners/site-banner.png"
          alt="Creator Profile"
          style={{
            position: "absolute",
            width: "100%",
            height: "100%",
            objectFit: "cover",
            transition: "opacity 0.3s ease-in-out",
          }}
        />
      </Box>
      <Box
        sx={{
          color: "#FFF",
          backgroundImage: `linear-gradient(to left, rgba(0, 0, 0, 0) 0%, rgba(15, 74, 105, 0.85) 85%)`,
          position: "absolute",
          backgroundSize: "cover",
          backgroundPosition: { xs: "center", mds: "top" },
          height: { xs: "150px", md: "200px" },
          px: { xxs: 1, xsm: 3, mds: 4 },
          alignItems: "center",
          display: "flex",
          width: { xs: "100%", xsm: "100%", mds: "1044px", sm: "1043px", lg: "1308px", xl: "1570px", xxl: "1835px" },
        }}
      >
        <Stack gap={1}>
          <Typography
            variant="h1"
            sx={{
              fontSize: { xs: "18px", md: "32px" },
              fontWeight: 700,
              lineHeight: { xs: "21.78px", md: "38.73px" },
              width: { xxs: "100%", xs: "90%", xsm: "65%" },
              wordBreak: "break-word",
              overflowWrap: "break-word",
            }}
          >
            The Best Networking Platform for SFW & NSFW Collabs
          </Typography>
          <Typography
            variant="body1"
            fontSize={{ xs: "14px", md: "16px" }}
            fontWeight={700}
            lineHeight={{ xs: "20px", md: "27px" }}
          >
            - Absolutely Free <br></br>- Verified Profiles
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export default React.memo(SiteBanner);
